import { Component } from "@angular/core";

@Component({
  selector: "settings-page",
  templateUrl: "settings.page.html"
})
export class SettingsPage {
  constructor(
  ) {
    // No empty block
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings.page/settings.page.ts